class MFRHeader {
  constructor(index, element) {
    this.$element = $(element);
    const headerMobile = new MFRHeaderMobile(element);

    this.selectors = {
      firstLevelLinks: ".mega-menu__first-level a",
      secondLevelLists: ".mega-menu__second-level ul",
      image: ".mega-menu__image",
      products: ".mega-menu__products",
      link: "a:not(.mega-menu__product)",
    };

    this.$element.addClass( "header--loaded" );
    this.initialize();
  }

  initialize() {
    this.$firstLevelLinks = this.$element.find(this.selectors.firstLevelLinks);
    this.$secondLevelLists = this.$element.find(
      this.selectors.secondLevelLists
    );
    this.$image = this.$element.find(this.selectors.image);
    this.$products = this.$element.find(this.selectors.products);
    this.$link = this.$element.find(this.selectors.link);
    this.initMegaMenu();
  }

  initMegaMenu() {
    this.initializeHoverEvents();
  }

  initializeHoverEvents() {
    $([...this.$firstLevelLinks]).on("mouseenter", this.showMenu.bind(this));
    this.$link.on("mouseenter", (e) => {
      this.showImage(e);
      this.showProducts(e);
    });
  }

  showMenu(e) {
    this.$firstLevelLinks.removeClass("hovered");
    this.$secondLevelLists.removeClass("open");
    if (
      !$(e.currentTarget).data("trigger-id") ||
      !this.$element.find(
        `${this.selectors.secondLevelLists}[data-menu-for="${$(
          e.currentTarget
        ).data("trigger-id")}"]`
      ).length
    )
      return;

    const secondLevel = this.$element.find(
      `${this.selectors.secondLevelLists}[data-menu-for="${$(
        e.currentTarget
      ).data("trigger-id")}"]`
    );

    secondLevel.addClass("open");
    $(e.currentTarget).addClass("hovered");
  }

  showImage(e) {
    this.$link.removeClass("hovered-for-image");
    this.$image.removeClass("open");
    if (
      !$(e.currentTarget).data("trigger-id") ||
      !this.$element.find(
        `${this.selectors.image}[data-image-for="${$(e.currentTarget).data(
          "trigger-id"
        )}"]`
      ).length
    )
      return;

    const image = this.$element.find(
      `${this.selectors.image}[data-image-for="${$(e.currentTarget).data(
        "trigger-id"
      )}"]`
    );

    image.addClass("open");
    $(e.currentTarget).addClass("hovered-for-image");
  }

  showProducts(e) {
    this.$link.removeClass("hovered-for-product");
    this.$products.removeClass("open");
    if (
      !$(e.currentTarget).data("trigger-id") ||
      !this.$element.find(
        `${this.selectors.products}[data-product-for="${$(e.currentTarget).data(
          "trigger-id"
        )}"]`
      ).length
    )
      return;

    const products = this.$element.find(
      `${this.selectors.products}[data-product-for="${$(e.currentTarget).data(
        "trigger-id"
      )}"]`
    );

    products.addClass("open");
    $(e.currentTarget).addClass("hovered-for-product");
  }
}

class MFRHeaderMobile {
  constructor( e ) {
    this.$element = $( e );

    this.selectors = {
      hamburger: ".mobile-menu-trigger",
      tabTitle: ".mobile-menu__tabs-title a",
      mobileMenu: ".mobile-menu",
      nav: ".mobile-menu__body nav",
      links: "a:not([aria-expanded]),a:not([data-tab-title])",
    };

    this.init();
  }

  init() {
    this.$hamburger = this.$element.find( this.selectors.hamburger );
    this.$tabTitle = this.$element.find( this.selectors.tabTitle );
    this.$mobileMenu = this.$element.find( this.selectors.mobileMenu );
    this.$nav = this.$element.find( this.selectors.nav );
    this.$links = this.$element.find( this.selectors.links );

    this.$mobileMenu.css({
      pointerEvents: "",
      visibility: "",
      opacity: ""
    })

    this.$hamburger.on( "click", this.__handleBurgerClick.bind( this ) );
    this.$tabTitle.on( "click", this.__handleTabClick.bind( this ) );
    this.$links.on( "click", this.__handleLinkClick.bind( this ) );
  }

  __handleLinkClick( e ) {
    const ariaExpanded =
      typeof $(e.currentTarget).attr("aria-expanded") !== "undefined" &&
      $(e.currentTarget).attr("aria-expanded") !== false;
    const tabTitle =
      typeof $(e.currentTarget).attr("data-tab-title") !== "undefined" &&
      $(e.currentTarget).attr("data-tab-title") !== false;

    if( ariaExpanded || tabTitle ) return;

    this.$hamburger.attr( "aria-expanded", "false" );
    this.closeMenu();
  }

  __handleBurgerClick( e ) {
    this.$hamburger.attr(
      "aria-expanded",
      this.$hamburger.attr("aria-expanded") == "false" ? "true" : "false"
    );

    if( this.$hamburger.attr( "aria-expanded" ) == "false" ) 
      this.closeMenu();
    else
      this.openMenu()
  }

  __handleTabClick( e ) {
    this.$tabTitle.removeClass( "is-active" );

    $( e.currentTarget ).addClass( "is-active" );

    this.showTab( $( e.currentTarget).data( "tab-title" ) );
  }

  openMenu() {
    this.$mobileMenu.addClass( "mobile-menu--open" );
    $("html,body").css("overflow", "hidden");
  }

  closeMenu() {
    this.$mobileMenu.removeClass("mobile-menu--open");
    $("html,body").css("overflow", "");
  }

  showTab( handle ) {
    this.$nav.removeClass( "is-active" );

    this.$element.find(`${this.selectors.nav}[data-menu-for="${handle}"]`).addClass( "is-active" );
  }
}


